import { UserProfileDTO } from '@/../client-generator/generated-clients/user';
import { createStore } from 'vuex';

import { client } from '../signalr/signalr';
import { APP_TITLE } from '../utilities/appconsts';
import profileModule from './modules/profile';
import * as Action from './types/action-types';

interface AppState {
  isAuthenticated: boolean;
  isLoading: boolean;
  sidebarShow: any;
  sidebarMinimize: boolean;
  token: string | null;
  profile: UserProfileDTO | null;
}

// In Vuex 4 non c'e piu un plugin da installare sul costruttore globale: si crea lo store con
// `createStore` e lo si passa con `app.use(store)`.
export default createStore({
  modules: {
    profileModule,
  },
  state: {
    isAuthenticated: false,
    token: null,
    isLoading: false,
    sidebarShow: 'responsive',
    sidebarMinimize: false,
    profile: null,
  },
  mutations: {
    [Action.API_REQUEST](state: AppState) {
      state.isLoading = true;
    },

    [Action.API_SUCCESS](state: AppState) {
      state.isLoading = false;
    },

    [Action.API_FAIL](state: AppState, error = 'Generic APP error') {
      state.isLoading = false;
      alert(error);
    },

    toggleSidebarDesktop(state) {
      const sidebarOpened = [true, 'responsive'].includes(state.sidebarShow);
      state.sidebarShow = sidebarOpened ? false : 'responsive';
    },
    toggleSidebarMobile(state) {
      const sidebarClosed = [false, 'responsive'].includes(state.sidebarShow);
      state.sidebarShow = sidebarClosed ? true : 'responsive';
    },
    set(state, [variable, value]) {
      state[variable] = value;
    },

    [Action.STORE_TOKEN](state, token) {
      state.token = token;

      if (token) {
        window.localStorage.setItem(`${APP_TITLE}_token`, token);
      } else {
        window.localStorage.removeItem(`${APP_TITLE}_token`);
      }
    },

    [Action.SET_AUTH_STATE](state, authState) {
      state.isAuthenticated = authState;
    },

    [Action.SET_PROFILE](state, profile) {
      state.profile = profile;

      if (profile) {
        client.init(() => {
          client.login(profile.id);
        });
      }
    },
  },

  actions: {
    [Action.READ_TOKEN]({ commit }) {
      const token = window.localStorage.getItem(`${APP_TITLE}_token`);
      if (token) {
        commit(Action.STORE_TOKEN, token);
      }
    },

    [Action.AUTHENTICATE]({ commit }, { token, authState }) {
      commit(Action.STORE_TOKEN, token);
      commit(Action.SET_AUTH_STATE, authState);
    },

    [Action.LOGOUT]({ commit }) {
      commit(Action.STORE_TOKEN, null);
      commit(Action.SET_AUTH_STATE, false);
      commit(Action.SET_PROFILE, null);
      client.logout();
    },

    [Action.SET_PROFILE]({ commit }, profile) {
      commit(Action.SET_PROFILE, profile);
      commit(Action.SET_AUTH_STATE, true);
    },
  },

  getters: {
    isAuthenticated: (state) => state.isAuthenticated,
  },
});
